<template>
    <div class="shop_product_list">
        <div v-for="(item,index) in proList" :key="index" class="pro"
             @click="$router.push({path:'/proDetail',query:{proId:item.id}})">
            <img :src="item.img" alt="">
            <div class="bottom_show">
                <div class="name"><strong>{{item.name}}</strong></div>
                <div class="desc">{{item.desc}}</div>
                <div class="price"><strong>¥ <span>{{item.price}}</span>.00</strong>/个</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                proList: [
                    // {
                    //     id: 1,
                    //     img: require('@/assets/images/shop/index/pic1.png'),
                    //     name: 'OMRON 蓝牙智能血压计 U32K',
                    //     desc: '智能健康管家',
                    //     price: 'xxx'
                    // },
                    // {
                    //     id: 2,
                    //     img: require('@/assets/images/shop/index/pic2.png'),
                    //     name: 'OMRON智能血压计 HEM-9200K',
                    //     desc: '革新健康方式，开启香槟人生',
                    //     price: 'xxx'
                    // },
                    {
                        id: 3,
                        img: require('@/assets/images/shop/index/pic3.png'),
                        name: 'MMC血糖院外管理套餐',
                        desc: '90天血糖随访管理+MMC血糖仪+50片血糖试纸+50支采血针',
                        price: '728'
                    }
                    // {
                    //     id: 4,
                    //     img: require('@/assets/images/shop/index/5.jpg'),
                    //     name: '吐司面包',
                    //     desc: 'GH若米吐司面包 40克×12片装 无面粉不升糖 糖友放心吃的吐司面包',
                    //     price: '53'
                    // },
                    // {
                    //     id: 5,
                    //     img: require('@/assets/images/shop/index/jianguo/1.png'),
                    //     name: '干果礼盒',
                    //     desc: '推荐_三只松鼠_每日坚果750g/30天装 孕妇零食节日礼物送女友混合干果礼盒',
                    //     price: '99'
                    // },
                    // {
                    //     id: 6,
                    //     img: require('@/assets/images/shop/index/niujiao/1.jpg'),
                    //     name: '牛角手撕面包',
                    //     desc: 'GH若米可颂牛角手撕面包无糖精低碳水糖尿人食品糖尿饼代餐早餐饱腹',
                    //     price: '58'
                    // },
                    // {
                    //     id: 7,
                    //     img: require('@/assets/images/shop/index/yumi/11.jpg'),
                    //     name: '有机黑玉米',
                    //     desc: '【有机】2020年新鲜玉米 有机黑玉米 10根真空包装 非转基因 甜糯玉米 现货包邮',
                    //     price: '60'
                    // },
                    // {
                    //     id: 8,
                    //     img: require('@/assets/images/shop/index/heisupian/11.jpg'),
                    //     name: '汤臣倍健褪黑素片',
                    //     desc: '【送VB30片2瓶】汤臣倍健褪黑素片60片',
                    //     price: '85'
                    // },
                    // {
                    //     id: 9,
                    //     img: require('@/assets/images/shop/index/weishengsu/11.jpg'),
                    //     name: '汤臣倍健B族维生素片',
                    //     desc: '汤臣倍健B族维生素片',
                    //     price: '131'
                    // }
                    // {
                    //     id: 10,
                    //     img: require('@/assets/images/shop/index/pic3.png'),
                    //     name: '汤臣倍健健力多氨糖软骨素钙片',
                    //     desc: '汤臣倍健健力多氨糖软骨素钙片70天关爱超值装280片',
                    //     price: 'xxx'
                    // }
                ]
            }
        }
    }
</script>

<style lang="less">
    .shop_product_list {
        overflow: hidden;
        margin-bottom: 20px;
        .pro {
            margin-right: 30px;
            float: left;
            padding-top: 20px;
            cursor: pointer;
            img {
                width: 217px;
                height: 208px;
            }
            .bottom_show {
                padding: 10px;
                background-color: #f4f4f4;
                .name {
                    font-size: 14px;
                    color: #000000;
                }
                .desc {
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    width: 197px;
                }
                .price {
                    strong {
                        font-size: 15px;
                    }
                    span {
                        font-size: 19.2px;
                        line-height: 21px;
                    }
                }
            }
            &:last-child {
                margin-right: 0px;
            }

        }
    }
</style>
